export enum UnidadMedida {
  Unidades = 0,
  Litros = 1,
  Kilogramos = 2,
  Libras = 3,
  Galon = 4
}
